import type { BoardDefinition } from "../types/game-data-config";
import { generateBaseBoard } from "./board-geometry";

// Synthetic 3-hex line: A0 -- M1 -- B0
// Used for unit tests (attack, bolster, move tests)
const TEST_LINE_3: BoardDefinition = {
  id: "test-line-3",
  hexes: ["0,0", "1,0", "2,0"],
  locations: ["0,0", "1,0", "2,0"],
  adjacency: {
    "0,0": ["1,0"],
    "1,0": ["0,0", "2,0"],
    "2,0": ["1,0"],
  },
  startLocations: {
    P1: ["0,0"],
    P2: ["2,0"],
  },
};

// Synthetic 4-hex line: A0 -- N1 -- N2 -- B0
// Used for deploy → move → control → win sequence tests
const TEST_LINE_4: BoardDefinition = {
  id: "test-line-4",
  hexes: ["0,0", "1,0", "2,0", "3,0"],
  locations: ["0,0", "1,0", "2,0", "3,0"],
  adjacency: {
    "0,0": ["1,0"],
    "1,0": ["0,0", "2,0"],
    "2,0": ["1,0", "3,0"],
    "3,0": ["2,0"],
  },
  startLocations: {
    P1: ["0,0"],
    P2: ["3,0"],
  },
};

const BASE_2P = generateBaseBoard();

export const BOARDS: Readonly<Record<string, BoardDefinition>> = {
  "test-line-3": TEST_LINE_3,
  "test-line-4": TEST_LINE_4,
  "base-2p": BASE_2P,
};
